import {
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import UserDialog from "./UserDialog";

interface ConfirmDeleteDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    itemName: string;
    loading?: boolean;
}

export default function ConfirmDeleteDialog({
                                                open,
                                                onClose,
                                                onConfirm,
                                                itemName,
                                                loading = false,
                                            }: ConfirmDeleteDialogProps) {
    return (
        <UserDialog open={open} handleClose={onClose}>
            <DialogTitle>Подтверждение удаления</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Вы действительно хотите удалить свойство "{itemName}"?
                    Оно будет перемещено в архив.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Отмена
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
                    {loading ? "Удаление..." : "Удалить"}
                </Button>
            </DialogActions>
        </UserDialog>
    );
}